export class CommonObject {
  id: number;
}
